import Http from '@/services/Http';

const path = 'envelopes';
const envelopes = new Http(path);

const appendContentObjectInFormData = (formData, content, key = false) => {
  formData.append(key !== false ? `${key}[value]` : 'value', content.value);
  formData.append(key !== false ? `${key}[type]` : 'type', content.type);
  formData.append(key !== false ? `${key}[page]` : 'page', content.page);
  formData.append(key !== false ? `${key}[x_axis]` : 'x_axis', content.x_axis);
  formData.append(key !== false ? `${key}[y_axis]` : 'y_axis', content.y_axis);
  formData.append(key !== false ? `${key}[width]` : 'width', content.width);
  formData.append(key !== false ? `${key}[height]` : 'height', content.height);
  formData.append(
    key !== false ? `${key}[font_size]` : 'font_size',
    content.font_size
  );

  formData.append(
    key !== false ? `${key}[font_family]` : 'font_family',
    content.font_family
  );
};

envelopes.create = (data) => envelopes.post(data, path);
envelopes.update = (envelopeId, data) =>
  envelopes.patch(envelopeId, data, path);
envelopes.getItem = (id) => envelopes.get(id);
envelopes.addRecipient = (envelopeId, data) =>
  envelopes.post(data, `${path}/${envelopeId}/recipients`);
envelopes.updateRecipient = (envelopeId, recipientId, data) =>
  envelopes.patch(recipientId, data, `${path}/${envelopeId}/recipients`);
envelopes.removeRecipient = (envelopeId, recipientId) =>
  envelopes.delete(recipientId, '', `${path}/${envelopeId}/recipients`);
envelopes.getExtendedEnvelope = (envelopeId) =>
  envelopes.get(`${envelopeId}?extended=true`);

envelopes.addDocumentContent = (envelopeId, documentId, data) => {
  if (data.type === 'image') {
    const formData = new FormData();
    appendContentObjectInFormData(formData, data);

    return envelopes.post(
      formData,
      `${path}/${envelopeId}/documents/${documentId}/contents`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  }
  return envelopes.post(
    data,
    `${path}/${envelopeId}/documents/${documentId}/contents`
  );
};

envelopes.addDocumentMultipleContents = (envelopeId, documentId, data) => {
  const hasImage = data.find((content) => content.type === 'image');

  if (hasImage) {
    const formData = new FormData();

    data.forEach(function (element, index) {
      appendContentObjectInFormData(formData, element, index);
    });

    return envelopes.post(
      formData,
      `${path}/${envelopeId}/documents/${documentId}/multiple-contents`,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  return envelopes.post(
    data,
    `${path}/${envelopeId}/documents/${documentId}/multiple-contents`
  );
};

envelopes.addDocumentField = (envelopeId, documentId, data) =>
  envelopes.post(data, `${path}/${envelopeId}/documents/${documentId}/fields`);

envelopes.addDocumentMultipleFields = (envelopeId, documentId, data) =>
  envelopes.post(
    data,
    `${path}/${envelopeId}/documents/${documentId}/multiple-fields`
  );

envelopes.removeDocumentField = (envelopeId, documentId, fieldId) =>
  envelopes.delete(
    fieldId,
    '',
    `${path}/${envelopeId}/documents/${documentId}/fields`
  );
envelopes.removeDocumentContent = (envelopeId, documentId, contentId) =>
  envelopes.delete(
    contentId,
    '',
    `${path}/${envelopeId}/documents/${documentId}/contents`
  );

envelopes.updateDocumentContent = (envelopeId, documentId, elementId, data) => {
  if (data.type === 'image') {
    const formData = new FormData();
    formData.append('_method', 'PATCH');
    appendContentObjectInFormData(formData, data);

    return envelopes.post(
      formData,
      `${path}/${envelopeId}/documents/${documentId}/contents/${elementId}`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  }

  return envelopes.patch(
    elementId,
    data,
    `${path}/${envelopeId}/documents/${documentId}/contents`
  );
};
envelopes.updateDocumentField = (envelopeId, documentId, elementId, data) =>
  envelopes.patch(
    elementId,
    data,
    `${path}/${envelopeId}/documents/${documentId}/fields`
  );

envelopes.excludeRecipientDocuments = (
  envelopeId,
  recipientId,
  documentsUuids
) =>
  envelopes.post(
    { exclude_documents: documentsUuids },
    `${path}/${envelopeId}/recipients/${recipientId}/exclude-documents`
  );

envelopes.listSent = (pathParams) =>
  envelopes.get('', '', `${pathParams === undefined ? '' : `?${pathParams}`}`);

envelopes.listFaceToFace = (pathParams) =>
  envelopes.get(
    '',
    '',
    `/face-to-face${pathParams === undefined ? '' : `?${pathParams}`}`
  );

envelopes.listReceived = (pathParams) =>
  envelopes.get(
    '',
    '',
    `/inbox${pathParams === undefined ? '' : `?${pathParams}`}`
  );

envelopes.listEvents = (envelopeId, params) =>
  envelopes.get(`${envelopeId}/events?sort=-created_at&page=${params.page}`);

envelopes.listEspecificEnvelope = (envelopeId, params) =>
  envelopes.get(envelopeId, params, '');

envelopes.sendEnvelope = (envelopeId) =>
  envelopes.post({}, `${path}/${envelopeId}/send`);

envelopes.cancelEnvelope = (envelopeId) =>
  envelopes.post('', `${path}/${envelopeId}/cancel`);

envelopes.deleteEnvelope = (envelopeId) =>
  envelopes.delete(envelopeId, '', path);

envelopes.addDocument = (envelopeId, file) =>
  envelopes.post({ file }, `${path}/${envelopeId}/documents`);

envelopes.addDocumentFile = (envelopeId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return envelopes.post(formData, `${path}/${envelopeId}/documents`, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

envelopes.removeDocument = (envelopeId, fileId) =>
  envelopes.delete(fileId, '', `${path}/${envelopeId}/documents`);

envelopes.listEnvelopeNotes = (envelopeId) =>
  envelopes.get('', '', `/${envelopeId}/notes`);

envelopes.reNotify = (envelopeId) =>
  envelopes.post('', `${path}/${envelopeId}/renotify`);

envelopes.download = (envelopeId) => {
  const config = {
    responseType: 'blob',
  };
  return envelopes.get('', '', `/${envelopeId}/download`, config);
};

envelopes.downloadBackgroundSheet = (envelopeToken) => {
  const config = {
    responseType: 'blob',
  };
  return envelopes.get(
    '',
    '',
    `/${envelopeToken}/background-sheet/download`,
    config
  );
};

envelopes.downloadEnvelopeDocumentsAndBackgroundSheet = (envelopeId) => {
  const config = {
    responseType: 'blob',
  };
  return envelopes.get('', '', `/${envelopeId}/completed/download`, config);
};

envelopes.getRecipientsState = (envelopeId) =>
  envelopes.get('', '', `/${envelopeId}/recipients`);

envelopes.copyTo = (into, envelopeId) =>
  envelopes.post({ into }, `${path}/${envelopeId}/copy`);

envelopes.deleteTemplate = (templateId) =>
  envelopes.delete('', '', `/${templateId}`);

envelopes.changeVisibility = (envelopeId, data) =>
  envelopes.post(data, `${path}/${envelopeId}/change-visibility`);

envelopes.getConfigs = () => envelopes.get('configs');

export default envelopes;
